import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ './views/DashboardPage.vue'),
    },
    {
        path: '/style-guide',
        name: 'style-guide',
        component: () => import(/* webpackChunkName: "home" */ './views/StyleGuide.vue'),
    },
    {
        path: '/dashboard-settings',
        name: 'dashboard-settings',
        component: () => import(/* webpackChunkName: "dashboard-settings" */ './views/DashboardSettings/DashboardSettings.vue'),
    },
    {
        path: '/layout-settings',
        name: 'layout-settings',
        component: () => import(/* webpackChunkName: "layout-settings" */ './views/LayoutSettings/LayoutSettings.vue'),
    },
    {
        path: '/dashboard-creation',
        name: 'dashboard-creation',
        component: () => import(/* webpackChunkName: "dashboard-creation" */ './views/DashboardCreation/DashboardCreation.vue'),
    },
    /*{
        path: '/generate-pdf',
        name: 'generate-pdf',
        component: () => import(/!* webpackChunkName: "modules" *!/ '@/modules/reports/types/pdf/pdf-wrapper'),
    },*/
    {
        path: '/reports',
        name: 'reports',
        redirect: 'reports',
        component: () => import(/* webpackChunkName: "reports" */'@/modules/reports/ReportsLayout'),
        children: [
            {
                path: '',
                name: 'reports-list',
                component: () => import(/* webpackChunkName: "reports-list" */ '@/modules/reports/pages/ReportsList'),
            },
            {
                path: 'edit/:id',
                name: 'reports-edit',
                component: () => import(/* webpackChunkName: "report-edit" */ '@/modules/reports/pages/ReportEdit'),
            },
            {
                path: 'create',
                name: 'reports-create',
                component: () => import(/* webpackChunkName: "report-create" */ '@/modules/reports/pages/ReportCreate'),
            },
        ],
    },
    {
        path: '*',
        name: 'Not Found',
        meta: {
            skipOrganizationCheck: true,
            productionReady: true,
        },
        beforeEnter () {
            window.location = `/`
        }
    },
]

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
})

export default router
